export default __webpack_public_path__ + "static/media/brand-logo.c5fc79d0.webp";